module.exports = "https://static.wmbcdn.com/uniweb/images/7b99406474d2be3ef8d185f4fcea314b.svg";